<template>
  <div class="lines-bg pt-20 pb-12 lg:pt-40">
    <contact-form :formData="fields" formName="Web Contact" sendKey="Help With" :content="{heading: 'You have questions. We have answers.'}" />
  </div>
</template>

<script>
import ContactForm from '~/components/common/ContactForm'
const contactFields = require('~/assets/config/contactUsForm.json')
import ContactSchema from '~/assets/src/contact-schema.json'

export default {
  components: {
    ContactForm
  },
  async asyncData({ $api }) {
    return {
      page: await $api.getPage('contact-us')
    }
  },
  data() {
    return {
      fields: contactFields,
      script: [{
        type: 'application/ld+json',
        json: ContactSchema
      }]
    }
  },
  head() {
    return this.$metadata(this.page)
  }
}
</script>
